import React from 'react';

import { observer } from 'mobx-react';

import { CustomListStoreContext } from 'bz-clinical/controls/settings/clinical-lists/stores/custom-list-store';
import type CustomListStore from 'bz-clinical/controls/settings/clinical-lists/stores/custom-list-store';

import NestedListList from './common/controls/list';
import MenuStore, {
  AlternatesContext,
  MenuPageContext,
  MenuStoreContext
} from './stores/menu-store';

export interface IProps {
  alternates: Map<string, any>;
  menu: Map<string, any>;
  store: CustomListStore;
}

@observer
class NestedList extends React.Component<IProps> {
  readonly menu = new MenuStore();

  constructor(props: IProps) {
    super(props);

    const { menu } = props;
    this.menu.onLoad(menu);
  }

  render() {
    const { alternates, store } = this.props;
    const page = this.menu.pages.get('main')!;

    return (
      <AlternatesContext.Provider value={alternates}>
        <CustomListStoreContext.Provider value={store}>
          <MenuStoreContext.Provider value={this.menu}>
            <MenuPageContext.Provider value={page}>
              <div className="nested-list">
                <NestedListList />
              </div>
            </MenuPageContext.Provider>
          </MenuStoreContext.Provider>
        </CustomListStoreContext.Provider>
      </AlternatesContext.Provider>
    );
  }
}

export default NestedList;
